export const ADD_ASSAD_COIN_REQUEST = "ADD_ASSAD_COIN_REQUEST";
export const ADD_ASSAD_COIN_SUCCESS = "ADD_ASSAD_COIN_SUCCESS";
export const ADD_ASSAD_COIN_FAILED = "ADD_ASSAD_COIN_FAILED";

export const AddAssadCoinAction = (data) => {
    return { type: ADD_ASSAD_COIN_REQUEST, payload: data };
};